import { alerts } from '../actions/Alerts';
import CONSTANTS from '../constants';
import ImageHelper from '../helpers/ImageHelper';
import AnalyticsService from '../services/AnalyticsService';
import LocationService from '../services/LocationService';

export function getLocation(locationId, history = {}, ordertime = Date.now()) {
  return async (dispatch) => {
    try {
      let location = await LocationService.getLocation(locationId);
      const menu = await LocationService.updateMenu(locationId, ordertime);
      location.menu_blob = JSON.stringify(menu);
      dispatch({ type: CONSTANTS.ACTIONS.LOCATIONS.GET, location: location });
    } catch (error) {
      console.log('Error: ', error);
      AnalyticsService.logEvent(CONSTANTS.EVENTS.GENERAL.ERROR, {
        event: CONSTANTS.EVENTS.GENERAL.ERROR,
        data: error.message
      });
      const connection = window.navigator.onLine;
      if (connection) {
        dispatch(alerts.error('LOCATION_NOT_FOUND', error.message));
      } else {
        dispatch(alerts.error('LOCATION_INTERNET', error.message));
      }

    }
  };
}


export function getPage(locationId, pageId) {
  return async (dispatch) => {
    try {
      let page = await LocationService.getPage(locationId, pageId);
      dispatch({ type: CONSTANTS.ACTIONS.LOCATIONS.PAGE, page: page });
    } catch (error) {
      console.log('Error: ', error);
      const connection = window.navigator.onLine;
      if (connection) {
        dispatch(alerts.error('PAGE_NOT_FOUND', error.message));
      } else {
        dispatch(alerts.error('LOCATION_INTERNET', error.message));
      }
    }
  };
}

export function setLocation(location) {
  return async (dispatch) => {
    try {
      if (location) {
        dispatch({ type: CONSTANTS.ACTIONS.LOCATIONS.GET, location: location });
      }
    } catch (error) {
      console.log('Error: ', error);
      dispatch(alerts.error('SET_LOCATION_NOT_FOUND', error.message));
    }
  };
}

export function clearLocation() {
  return async (dispatch) => {
    dispatch({ type: CONSTANTS.ACTIONS.LOCATIONS.GET, location: null });
    dispatch({ type: CONSTANTS.ACTIONS.LOCATIONS.SETTINGS, locationSettings: null });
    dispatch({ type: CONSTANTS.ACTIONS.ITEMS.LIST, items: null });
    dispatch({ type: CONSTANTS.ACTIONS.ITEMS.POPULAR_LIST, popularItems: null });
    dispatch({ type: CONSTANTS.ACTIONS.CATEGORIES.LIST, categories: null });
  };
}

export function clearItems() {
  return async (dispatch) => {
    dispatch({ type: CONSTANTS.ACTIONS.ITEMS.LIST, items: null });
    dispatch({ type: CONSTANTS.ACTIONS.ITEMS.POPULAR_LIST, popularItems: null });
    dispatch({ type: CONSTANTS.ACTIONS.CATEGORIES.LIST, categories: null });
  };
}

export function getNearByLocations(latitude, longitude) {
  return async (dispatch) => {
    try {
      let nearByLocations = await LocationService.getNearByLocations(latitude, longitude);
      dispatch({ type: CONSTANTS.ACTIONS.LOCATIONS.LIST, nearByLocations });
    } catch (error) {
      console.log('Error: ', error);
      dispatch(alerts.error('NEAR_BY_LOCATIONS_NOT_FOUND', error.message));
    }
  };
}

export function getChildLocations(parentId, currentLocation) {
  return async (dispatch) => {
    try {
      let childLocations = await LocationService.getChildLocations(parentId, currentLocation);
      dispatch({ type: CONSTANTS.ACTIONS.LOCATIONS.CHILDREN, childLocations });
    } catch (error) {
      console.log('Error: ', error);
      dispatch(alerts.error('CHILD_LOCATIONS_NOT_FOUND', error.message));
    }
  };
}

export function getOutlets(parentLocation) {
  return async (dispatch) => {
    try {
      const outlets = await LocationService.getOutlets(parentLocation.loc_id);
      const menu = await LocationService.updateMenu(parentLocation.loc_id, Date.now());
      for (let i = 0; i < outlets.length; i++) {
        outlets[i].menu_blob = JSON.stringify(menu);
      }
      dispatch({ type: CONSTANTS.ACTIONS.LOCATIONS.OUTLETS, outlets, parentLocation });
    } catch (error) {
      console.log('Error: ', error);
      dispatch(alerts.error('OUTLETS_LOCATIONS_NOT_FOUND', error.message));
    }
  };
}

export function getLocationLayoutSettings(locationId) {
  return async (dispatch) => {
    try {
      let locationSettings = await LocationService.getLocationSettings(locationId);
      const root = document.documentElement;
      root.style.setProperty('--primary-color', locationSettings?.main_bg_color);
      root.style.setProperty('--primary-font-color', locationSettings?.section_font_color);
      root.style.setProperty('--primary-error-color', locationSettings?.h2_color);
      root.style.setProperty('--card-color', locationSettings?.card_color);
      root.style.setProperty('--card-font-color', locationSettings?.main_font_color_1);
      root.style.setProperty('--card-subtitle-color', locationSettings?.main_font_color_2);
      root.style.setProperty('--card-outline-color', locationSettings?.card_outline);
      root.style.setProperty('--card-error-color', locationSettings?.h2_text_color);
      root.style.setProperty('--highlight-color', locationSettings?.highlight_color);
      root.style.setProperty('--highlight-text-color', locationSettings?.highlight_text_color);
      root.style.setProperty('--button-color', locationSettings?.btn_color);
      root.style.setProperty('--button-font-color', locationSettings?.btn_font_color);
      root.style.setProperty('--button-outline-color', locationSettings?.btn_outline);
      root.style.setProperty('--header-bg-color', locationSettings?.basecolor);
      root.style.setProperty('--header-font1-color', locationSettings?.header_font_color_1);
      root.style.setProperty('--announcement-bg', locationSettings?.announcement_bg);
      root.style.setProperty('--announcement-text-color', locationSettings?.announcement_text_color);
      root.style.setProperty('--footer-bg-color', locationSettings?.footer_bg);
      root.style.setProperty('--footer-text-color', locationSettings?.footer_text_color);

      if (locationSettings.logo)
        document.getElementById("favicon").href = ImageHelper.getImageURL(locationSettings.logo, '?func=cover&h=250');
      dispatch({ type: CONSTANTS.ACTIONS.LOCATIONS.SETTINGS, locationSettings });
    } catch (error) {
      console.log('Error: ', error);
      dispatch(alerts.error('SETTINGS_NOT_FOUND', error.message));
    }
  };
}
